import { IncomeModel } from '../../api/useIncomeQuery';
import { IncomeData } from '../../useIncome';
import { WorkflowComponentProps } from '../../../../Workflow/Workflow.meta';

export const UPSERT_INCOME_FORM_ID = 'income--upsert-income--form';

export interface UpsertIncomeFormProps {
  clientId: string;
  income: (IncomeModel & { isClone?: boolean }) | null;
  data: IncomeData;
  onSuccess: () => void;
  workflowProps?: WorkflowComponentProps;
  onDirtyChange?: (dirty: boolean) => void;
}
